import React, { useCallback, useEffect, useState } from "react";
import FormDesigner from "../FormDesigner";
import { Switch, Route, Redirect } from "react-router-dom";
import FormStart from "../FormStart";
import api from "lib/api";
import { Loading } from "@alm/flow-ds/components";
import DashboardLayout from "components/Layouts/DashboardLayout";
import axios from "axios";

export default function FormDesignerLayout() {
	const [validUser, setValidUser] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(true);

	// Check if the user is logged in and has the right
	// role to use the Form Designer
	const checkIsUserValid = useCallback(async () => {
		try {
			const authen = await api.tokens.validate();
			const author = await api.roles.getIsUserFormDesigner();
			authen && author && setValidUser(true);
			setLoading(false);
		} catch (error) {
			if (error && axios.isAxiosError(error))
				console.error(`Error: ${error.message}`);
		}
	}, []);

	useEffect(() => {
		checkIsUserValid();
	}, [checkIsUserValid]);

	return (
		<DashboardLayout>
			{loading ? (
				<Loading className="mt-5 elem__loader--lg" />
			) : validUser ? (
				<Switch>
					<Route exact path="/formdesigner" component={FormStart} />
					<Route
						path="/formdesigner/create"
						component={FormDesigner}
					/>
					{/* Redirect to 404 page */}
					<Redirect to={"/404"} />
				</Switch>
			) : (
				// Redirect to 403 page in flow
				<Redirect to={"/403"} />
			)}
		</DashboardLayout>
	);
}
